import axios from 'axios'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

import { environment } from '../../../environment'

import { MAIN_HEADER_REQUEST, ENC_METHODS } from './constants'
import { $getLoginRefreshFx, $getLogoutFx } from '../../store/Auth/event'
import { $authToken, $refreshLoading } from '../../store/Auth/store'

const apiURL = environment.API_PREFIX

let fingerprint: null | string = null;
(async () => {
  // Get the visitor identifier when you need it.
  const fp = await FingerprintJS.load()
  fingerprint = (await fp.get()).visitorId
})()

export enum AxiosInstanceType {
  JSON = 'JSON',
  FORMDATA = 'FORM_DATA',
}

/**
 * Настройки для axios
 *
 * @param {string} type 'JSON' | 'FORM_DATA'
 * @returns
 */
const AxiosInstance = (type: AxiosInstanceType = AxiosInstanceType.JSON) => {
  let contentType = 'application/json'
  if (type === AxiosInstanceType.FORMDATA) {
    contentType = 'multipart/form-data'
  }

  const token = $authToken.getState()
  const refreshLoading = $refreshLoading.getState()

  const instance = axios.create({
    baseURL: apiURL,
    headers: {
      ...MAIN_HEADER_REQUEST,
      'Content-Type': contentType,
      'x-trace-id': `web:${Date.now()}`,
    },
    withCredentials: true,
    validateStatus: (status) => {
      if (status === 401 && token && !refreshLoading) {
        $getLoginRefreshFx(null)
      }
      if (status === 403) {
        $getLogoutFx()
      }
      return status <= 500
    },
  })

  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`
  }
  if (fingerprint) {
    instance.defaults.headers.common['x-fingerprint'] = fingerprint
  }

  instance.interceptors.request.use(
    (config) => {
      const { method = '', data = {} } = config

      // eslint-disable-next-line no-prototype-builtins
      if (ENC_METHODS.hasOwnProperty(method) && config?.headers?.['Content-Type'] !== 'multipart/form-data') {
        return {
          ...config,
          data: JSON.stringify({ ...data }),
        }
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  return instance
}

export default AxiosInstance
